module.exports = __webpack_public_path__ + "img/quxiaoquanping.0c36caff.png";